import { Component, OnInit, TemplateRef, Input } from '@angular/core';
import { AuctionAnnouncement } from '../../../../models/auctionAnnouncement';
import { FormControl, Validators, AbstractControl } from '@angular/forms';
import constants from '../../../../utility/constants';
import { AuctionAnnouncementService } from '../../../../services/auction-announcement.service';
import { ToastrService } from 'ngx-toastr';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap/modal';
import { LoaderService } from '../../../../services';
import { Observable, Subscription } from 'rxjs';
import { GetAuctionStep1 } from '../../../../models';

export enum AnnouncementMode {
  Add = 1,
  Edit,
  Remove
}

@Component({
  selector: 'app-auction-announcement',
  templateUrl: './auction-announcement.component.html',
  styleUrls: ['./auction-announcement.component.css']
})
export class AuctionAnnouncementComponent implements OnInit {
  @Input() auctionId: number;
  @Input() auction: GetAuctionStep1;
  announcementModes = AnnouncementMode;
  currentAnnouncementMode: number;
  auctionAnnoucement: AuctionAnnouncement;
  announcementText: string;
  announcementControl: FormControl;
  isEditorCharLimitReached: boolean;
  announcementMaxLength: number = constants.common.validations.maxLength1000;

  modalRef: BsModalRef;
  private subscriptions: Array<Subscription> = [];
  constructor(
    private auctionAnnoucementService: AuctionAnnouncementService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.announcementControl = new FormControl(null, [Validators.required]);
    this.getAnnouncement();
  }

  openAnnouncementModal(template: TemplateRef<any>, mode: number) {
    this.currentAnnouncementMode = mode;
    let modalOptions: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      class:
        'custom-popup form-modal modal-dialog modal-dialog-centered',
    };
    this.modalRef = this.modalService.show(template, modalOptions);
  }

  public editorContent(event: { data: string, limitReached: boolean }, control: AbstractControl) {
    control.patchValue(event.data);
    control.markAsDirty();
    if (event.limitReached)
      control.setErrors({ invalid: true })
    else
      control.setErrors(null);
  }

  getAnnouncement() {
    const announcments = this.auctionAnnoucementService.getAuctionAnnouncementById(this.auctionId).subscribe((res) => {
      this.auctionAnnoucement = (res?.isActive) ? res : null;
      this.announcementText = (res?.isActive) ? res?.text : null;
      this.announcementControl.patchValue(res?.text);
    })
    this.subscriptions.push(announcments);
  }

  announcementChanges() {
    if (this.announcementControl.invalid)
      return;

    this.loaderService.showLoader(true);
    let currentMode: string;
    let request: Observable<any>;
    let announcementText = this.announcementControl.value;
    if (this.currentAnnouncementMode === this.announcementModes.Add) {
      request = this.auctionAnnoucementService.addEditRemoveAuctionAnnouncement(this.auctionId, announcementText);
      currentMode = "Added";
    } else if (this.currentAnnouncementMode === this.announcementModes.Edit) {
      request = this.auctionAnnoucementService.addEditRemoveAuctionAnnouncement(this.auctionId, announcementText);
      currentMode = "Edited";
    } else if (this.currentAnnouncementMode === this.announcementModes.Remove) {
      request = this.auctionAnnoucementService.addEditRemoveAuctionAnnouncement(this.auctionId, announcementText, true);
      currentMode = "Removed";
    }
    if (request) {
      const reqst = request.subscribe((res) => {
        this.loaderService.showLoader(false);
        this.toastr.success(`Announcement ${currentMode} Successfully`, constants.common.toast.successTitle, constants.common.toast.config);
        this.auctionAnnoucement = (res?.isActive) ? res : null;
        this.announcementText = (res?.isActive) ? res?.text : null;
        this.announcementControl.patchValue(res?.text);
        this.closeModal();
      }, (err) => {
        this.loaderService.showLoader(false);
        this.toastr.error(err, constants.common.toast.errorTitle, constants.common.toast.config);
      })
      this.subscriptions.push(reqst);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }

  closeModal() {
    if (this.modalRef) {
      this.modalRef.hide();
    }
  }
}
